















































import { Component, Vue, Watch, Ref, Prop } from 'vue-property-decorator'
import uploader from '@/components/commonForm/uploader.vue'
import { Route } from 'vue-router'
import uploadList from './components/uploadList.vue'
import { addDiscussion, getDiscussionList } from '@/apis/sheet'
import { formatShortTime } from '@/utils/common'
import avatar from '@/components/avatar/index.vue'
import {uuid} from '@/utils/common'
import { Toast } from 'vant'
@Component({
  name: 'comment',
  components: {
    uploadList,
    avatar,
    uploader
  },
  filters: {
      dateFilter: (value: any) => {
        return formatShortTime(value)
      }
    }
})
export default class extends Vue {
  @Prop() public worksheetId!: string
  @Prop() public id!: string
  private inputVal = ''
  private fileList = [] as any []
  private ulList = [] as any []
  private loading = false
  private finished = false
  private page = { pageNumber: 0, pageSize: 20, total: 0 }
  private totalPage = 1
  private progress: any = null
  private remove (index: number) {
    this.fileList.splice(index, 1)
  }
  private keyFun (type) {
    let companyId = this.$store.state.user.user.companyId
    return `${companyId}/discussion/${this.worksheetId}/${uuid()}.` + type
  }
  private progressFn (data) {
    this.progress = data
  }
  private blurInput () {
    this.sendComment()
  }
  private uploadSuccess (file) {
    this.fileList.push(file)
    this.progress = null
    this.sendComment()
  }
  private onLoad () {
    this.getFetchDiscussionData(false)
  }
  private async getFetchDiscussionData (isStart) {
    const pageNum = this.page.pageNumber + 1
    let {recordId, worksheetId} = this.$route.params
    const data = {
      worksheetId,
      recordId,
      page: {
        pageNumber: pageNum,
        pageSize: this.page.pageSize
      }
    }
    let res = await getDiscussionList(data)
    if (res.success) {
      this.loading = false
      this.page.pageNumber = pageNum
      this.page.total = res.data.page.total
      if (isStart || pageNum === 1) {
        this.ulList = res.data.discussions || []
      } else {
        this.ulList = this.ulList.concat(res.data.discussions)
      }
      this.finished =  this.ulList.length >= this.page.total
    } else {
      this.loading = false
    }
  }
  private async sendComment () {
    if (!this.inputVal && this.fileList.length === 0) {
      return false
    } else {
      let data = {
        worksheetId: this.$route.params.worksheetId,
        recordId: this.$route.params.recordId,
        discussContent: this.inputVal,
        accessories: this.fileList
      }
      let res = await addDiscussion(data)
      if (res.code === 200) {
        this.fileList = []
        this.inputVal = ''
        this.page = { pageNumber: 0, pageSize: 20, total: 0 }
        this.getFetchDiscussionData(true)
      }
    }
  }
  private mounted () {
    this.getFetchDiscussionData(true)
  }
}
